import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { DisciplineCard } from './components/Card/DisciplineCard';
import { getDisciplinePagedOptions } from './model/DisciplineQuery';

export function DisciplineBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(getDisciplinePagedOptions({ ...pagination, sortDirection, search }));
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('disciplines.title')}
      subtitle={t('disciplines.subtitle')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('disciplines.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('disciplines.sortedByName')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={discipline => (
        <DisciplineCard
          key={discipline.id}
          discipline={discipline}
          to={`${discipline.id}`}
        />
      )}
    />
  );
}
